export function formatVariantCell(value, colId) {
    if (!value) return "";

    if (colId === "VANEX_NOTES") {
        return (
        value.CURRENT_USER_NOTE.replace(/\n/g, " ") +
        "[" +
        value.ALL_USERS_NOTES
            .filter(n => n.IS_SET_BY_OTHERS)
            .map(
            x => ` «${x.USERNAME}»: ${x.VANEX_NOTES.replace(/\n/g, " ")}`
            )
            .join("], [") +
        "]"
        );
    }

    if (colId === "VANEX_REVIEWS") {
        return value.REVIEW_VALUE;
    }

    if (typeof value === "string") {
        return value.replace(/\t|\n/g, " ").trim();
    }

    return value;
}